module.exports = __webpack_public_path__ + "media/12_la_cucaracha_horn.03aac42a.mp3";